// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2ATEQ","buttons":"SendReceipts_buttons__1UBWr","email":"SendReceipts_email__34t1z","bookApptTitle":"SendReceipts_bookApptTitle__2tzkW"};